import React, { useEffect, useState, useCallback } from 'react';

import CloseIcon from "../../assets/images/close.png";
import Popup from 'reactjs-popup';
import { TfiTrash } from "react-icons/tfi";
import { Disable } from 'react-disable';
import Select, { components } from "react-select";

import { useDrop } from 'react-dnd';
import { connect } from "react-redux";
import { compose } from "redux";

import { getUsers } from "../../store/actions/adminActions";
import FindingOverlay from './FindingOverlay';

import {addFindingAI, deleteFinding, updateFinding, addFinding, addAttachment, editControl, deleteControl, getControlDetails, addControlComment, deleteAttachment } from "../../store/actions/riskActions";

import { callOpenAIAPIFindings  } from "../../utils/openAI.js";
import moment from 'moment';
import debounce from "lodash/debounce";


const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: 'none', // Remove the border
        boxShadow: state.isFocused
            ? 'inset 0 -2px 0 0 #3b3b3b' // Add a focused bottom border effect using boxShadow
            : 'none', // Default to light gray bottom shadow
        backgroundColor: '#EEF0ED',
        padding: 1,
        transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
        '&:hover': {
            boxShadow: state.isFocused
                ? 'inset 0 -2px 0 0 #3b3b3b' // Keep dark blue on hover if focused
                : 'inset 0 -2px 0 0 #ccc', // Otherwise, show light gray on hover
        },
    }),

    menu: (provided) => ({
        ...provided,
        border: 'none', // Remove the border around the menu
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#3b3b3b'
            : state.isFocused
                ? '#EEF0ED'
                : 'white', // Different background colors for selected, focused, and default
        color: state.isSelected ? 'white' : '#000',
        '&:hover': {
            backgroundColor: '#EEF0ED', // Light background on hover
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),

};






const ControlOverlay = (props) => {

    const { deleteFindingFN, updateFindingFN, addFindingFN, addFindingAIFN, findings, fetchAISuggestions, loadingAI, risk_id, addAttachmentFN, editControlFN, users, profile, getUsersFN, closeControl, getControlDetailsFN, control_id, control_details, control_comments, addControlCommentFN, deleteAttachmentFN } = props;


    const fileInputRef = React.useRef(null);

    const handleFileChange = (event, control) => {
        const files = Array.from(event.target.files); // Convert FileList to an array
        if (files?.length > 0) {
            setFormState((prevState) => ({
                ...prevState,
                Attachments: [...prevState.Attachments, ...files], // Append new files to existing attachments
            }));
            // Optionally, send files to the backend
            files.forEach((file) => addAttachmentFN(risk_id, control, file));
        }
    };

    const handleDeleteAttachment = (attachmentId) => {
        // Call the deleteAttachmentFN action
        props.deleteAttachmentFN(control_id, attachmentId)
            .then(() => {
                // Update the state by removing the deleted attachment
                setFormState((prevState) => ({
                    ...prevState,
                    Attachments: prevState.Attachments.filter(
                        (attachment) => attachment.attachment_id !== attachmentId
                    ),
                }));
            })
            .catch((error) => {
                console.error("Error deleting attachment:", error);
            });
    };

    const handleAttachmentClick = (control) => {

        if (formState.ControlAttachment) {
            window.open(formState.ControlAttachment, '_blank');
        } else {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    };


    const closeFinding = async (data, finding_id) => {
        if (!finding_id)
            return
        setIsFindingOpen(false)
        setFindingID(null)
        await updateFindingFN(data, finding_id)
        getControlDetailsFN(risk_id, control_id);
        console.log("close finding", data, " ", finding_id)

    }

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";

        // Convert string to Date object (ensure it's treated as UTC)
        const date = new Date(dateString);

        // Get the date components in UTC to prevent timezone shifts
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getUTCDate()).padStart(2, "0");

        return `${year}-${month}-${day}`; // Return properly formatted YYYY-MM-DD
    };


    const [isLoading, setIsLoading] = useState(true);

    const [newItemLocal, setNewItemLocal] = useState("");

    const [commentState, setCommentState] = useState('');

    const [currentPage, setCurrentPage] = useState(1);

    const [findingBusy, setFindingBusy] = useState(false);

    const [formState, setFormState] = useState({
        Title: '',
        Definition: '',
        ControlType: '',
        ControlPeriod: '',
        ControlPeriodCustom: '',
        Attachments: [],
        User: '',
        ControlEfficiency: '',
        StartDate: moment().format('YYYY-MM-DD'),
        EndDate: moment().format('YYYY-MM-DD'),
        Finding: '',
        Recommendation: '',
        Secondline: '',
        secondFindings: '',
        secondRecommendations: '',
        is_secondline: false,
        Checklist: [],
        compliance_types: [],
    });


    const [findingId, setFindingID] = useState(null);
    const [isFindingOpen, setIsFindingOpen] = useState(false);



    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: 'CONTROL',
        drop: (item) => {
            ////console.log("Dropped item index:", item.index);
            ////console.log(controls);
            // Access the correct control from the latest state
            const droppedControl = item.control;
            ////console.log("Dropped control:", droppedControl);

            // Handle the drop with the correct control
            handleDrop(droppedControl);
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));


    const handleDrop = (droppedChecklist) => {
        setFormState(prev => {
            const newChecklist = [
                ...(prev.Checklist || []),
                { text: droppedChecklist.text.trim(), completed: false },
            ];
            return { ...prev, Checklist: newChecklist };
        });
        // or: handleRiskChange({ Checklist: newChecklist });  // but compute with prev
    };

     const handleDropFinding = async (droppedChecklist) => {
       const updatedChecklist = formState.Checklist.filter((_, idx) => idx !== droppedChecklist.index);
        handleRiskChange({ ...formState, Checklist: updatedChecklist });
        let normCompleted
        if( droppedChecklist.completed){
            normCompleted = "true"
        } else {
             normCompleted = "false"
        }
        setFindingBusy(true)
        const aiResponse = await callOpenAIAPIFindings( droppedChecklist.text, normCompleted );
        setFindingBusy(false)
        console.log("aiResponse ", aiResponse)
        addFindingAIFN(control_id, aiResponse)
    };




    const listControlTypes = [{ value: 'Detective', label: 'Detective', color: "#000000" }, { value: 'Preventive', label: 'Preventive', color: "#000000" }, { value: 'Corrective', label: 'Corrective', color: "#000000" }, { value: 'Mitigative', label: 'Mitigative', color: "#000000" }];
    const listControlPeriods = [{ value: 'Daily', label: 'Daily', color: "#000000" }, { value: 'Monthly', label: 'Monthly', color: "#000000" }, { value: 'Quarterly', label: 'Quarterly', color: "#000000" }, { value: 'Weekly', label: 'Weekly', color: "#000000" }];



    const [draggedChecklistItem, setDraggedChecklistItem] = useState(null);

    useEffect(() => {
        //alert(control_id);
        // getRiskFN(risk_id);
        //console.log("risk_id", risk_id);
        getUsersFN();
        getControlDetailsFN(risk_id, control_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [control_id]);

    //console.log("frontend control details", control_details);
    // //console.log("risk_id", risk_id);
    useEffect(() => {
        if (control_details) {
            console.log("Fetched Control Detail:", control_details);

            const matchedControlType = listControlTypes.find(
                (controlType) => controlType.value === control_details.control_type
            );
            const matchedControlPeriod = listControlPeriods.find(
                (controlPeriod) => controlPeriod.value === control_details.control_period
            );

            let newUser = listUsers.find(user => user.value === control_details.user_id);
            console.log("new user", newUser)

            setFormState({
                Title: control_details.control_details || '',
                Definition: control_details.control_definition || '',
                ControlType: control_details.control_type || null,
                ControlPeriod: matchedControlPeriod || null,
                ControlPeriodCustom: control_details.control_period_custom || '',
                Attachments: control_details.attachments, // Directly use control_details.attachments
                ControlEfficiency: control_details.efficiency_level || '',
                User: newUser,
                StartDate: control_details.start_date
                    ? moment(control_details.start_date).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD"),
                EndDate: control_details.end_date
                    ? moment(control_details.end_date).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD"),
                Finding: control_details.finding || '',
                Recommendation: control_details.recommendation || '',
                Secondline: control_details.secondline || '',
                is_secondline: control_details.is_secondline === 1 ? true : false,
                secondFindings: control_details.secondFindings || '',
                secondRecommendations: control_details.secondRecommendations || '',
                Checklist: control_details.Checklist,
                compliance_types: control_details.compliance_types
                    ? control_details.compliance_types.split(",").map(s => s.trim())
                    : [],
            });
        }
    }, [control_details]);



    useEffect(() => {
        if (control_details) {
            setIsLoading(false);
        }
    }, [control_details]);






    const Option = (props) => (
        <components.Option {...props}>
            <div className="flex items-center gap-2">
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    readOnly
                    className="pointer-events-none"
                />
                <span>{props.label}</span>
            </div>
        </components.Option>
    );

    // ✅ Custom value container (no chips, just count)
    const ValueContainer = ({ children, ...props }) => {
        const values = props.getValue();
        const count = values?.length ?? 0;

        return (
            <components.ValueContainer {...props}>
                {count === 0 ? (
                    children /* show placeholder if nothing picked */
                ) : (
                    <div className="text-sm text-[#3b3b3b]">{count} selected</div>
                )}
            </components.ValueContainer>
        );
    };

    // ✅ Hide the clear "x" button
    const ClearIndicator = () => null;

    // ✅ Options list
    const complianceOptions = [
        { value: "NIST", label: "NIST" },
        { value: "COBIT", label: "COBIT" },
        { value: "ISO 27001", label: "ISO 27001" },
        { value: "GDPR", label: "GDPR" },
    ];

    const headerStyle = {
        background: "#E2E4E0",
        color: "#1F1F1F",
        fontSize: 13,
        fontWeight: 500,
        padding: "4px 12px",
        height: 28,
        borderBottom: "1px solid #D8DBD6",
    };



    const handleAddFinding = async (control_id) => {
        console.log("adding finding")
        addFindingFN(control_id, 0)

    }

    const handleAddFindingSecond = async (control_id) => {
        console.log("adding finding second")
        addFindingFN(control_id, 1)

    }


    const handleFindingClick = async (id) => {
        console.log("opeining ", id)
        setFindingID(id);
        setIsFindingOpen(true)

    }

    const handleDeleteFinding = async (id) => {
        console.log("deleting ", id)
        await deleteFindingFN(id);
        getControlDetailsFN(risk_id, control_id)



    }



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateServerData = useCallback(
        debounce((data, type, control_id, action_id) => {
            //console.log("CONTROL DATA BEFORE ADJUSTMENT", data);

            // Clone data to avoid modifying state directly
            const updatedData = { ...data };

            // Add one day to StartDate and EndDate if they exist
            if (updatedData.StartDate) {
                const startDate = new Date(updatedData.StartDate);
                startDate.setDate(startDate.getDate() + 1);
                updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            }

            if (updatedData.EndDate) {
                const endDate = new Date(updatedData.EndDate);
                endDate.setDate(endDate.getDate() + 1);
                updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            }

            //console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

            setIsLoading(true);
            editControlFN(risk_id, control_id, updatedData);
        }, 1500),
        []
    );



    // const handleRiskChange = (data) => {
    //     ////console.log("Risk change dfata:", data);
    //     setFormState(data);
    //     updateServerData(data, "control", control_id);

    // };

    const compliancePillClass = (t) => {
        const map = {
            "NIST": "bg-blue-100 text-blue-800 border-blue-300",
            "COBIT": "bg-purple-100 text-purple-800 border-purple-300",
            "ISO 27001": "bg-emerald-100 text-emerald-800 border-emerald-300",
            "GDPR": "bg-amber-100 text-amber-900 border-amber-300",
        };
        return map[t] || "bg-gray-100 text-gray-800 border-gray-300";
    };

    const listUsers = users && users?.length > 0 ? users.map(user => ({ value: user.user_id, label: user.first_name + ' ' + user.last_name })) : [];
    const selectedOwner =
        formState?.User == null
            ? null
            : (listUsers.find(o => String(o.value) === String(formState.User)) ?? null);

    const handleRiskChange = (data) => {
        console.log("Handle Control change data", data);
        setFormState((prevState) => ({
            ...prevState,
            ...data, // Spread only the updated fields
            Attachments: data.Attachments || prevState.Attachments, // Preserve Attachments explicitly

        }));



        //updateServerData(data, "control", control_id);
    };


    ////console.log("Random Control Details Log:",control_details);
    ////console.log("formstate:", formState);




    const disableEvent = React.useCallback(
        (e) => {
            if (isFindingOpen) return;           // ← do nothing while child modal is open
            if (profile.role === "Auditor") {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        [isFindingOpen, profile.role]
    );


    return (
        <Disable disabled={isLoading} onClick={disableEvent} onKeyDown={disableEvent}>
            <div style={profile.role === "Auditor" ? { pointerEvents: 'none', userSelect: 'none' } : { pointerEvents: 'auto', userSelect: 'auto' }} className='p-8'>

                {formState.is_secondline === true && (<div className="flex justify-left mb-1">
                    <button
                        onClick={() => setCurrentPage(1)}
                        className={`px-4 py-2 mx-2 transition duration-100 
                                ${currentPage === 1
                                ? 'w-fit border-b-2 border-[#3b3b3b] border-solid text-[#3b3b3b] font-semibold'
                                : 'w-fit border-b-2 border-transparent border-solid text-gray-500'}`}
                    >
                        Control
                    </button>

                    <button
                        className={`w-fit px-4 py-2 mx-2 border-b-2 transition duration-100 ${currentPage === 2
                            ? 'border-[#3b3b3b] text-[#3b3b3b] font-semibold'
                            : 'border-transparent text-gray-500'
                            }`}
                        onClick={() => setCurrentPage(2)}
                    >
                        Second Line
                    </button>
                </div>
                )}



                <div className="flex justify-between items-center mb-1">
                    <img src={CloseIcon} alt="Close" className="w-6 h-6 cursor-pointer absolute top-2 right-2" onClick={() => closeControl(formState, control_id, risk_id)} />
                </div>
                {currentPage === 1 && (
                    <div className={`p-6 bg-white rounded-lg`}>

                        <div className="flex justify-between items-center mb-1">
                            <label className="text-[#3b3b3b] mb-1 text-sm">Title</label>
                        </div>

                        <div className="mb-4">
                            <input
                                type="text"
                                placeholder="Title"
                                value={formState.Title}
                                onChange={(e) => handleRiskChange({ ...formState, Title: e.target.value })}
                                className="w-full p-3 text-sm rounded mb-4 bg-[#EEF0ED] text-black"
                                style={{
                                    border: 'none', // Remove actual borders
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur

                            />
                            <textarea
                                placeholder="Definition"
                                value={formState.Definition}
                                onChange={(e) => handleRiskChange({ ...formState, Definition: e.target.value })}
                                className="w-full p-3 text-sm rounded bg-[#EEF0ED] text-black"
                                style={{
                                    border: 'none', // Remove actual borders
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                            />

                            <div className="mb-4">


                                {/* 👇 Selected compliance types as colored pills */}
                                <div className="mt-2">

                                    <div className="flex flex-wrap gap-2">
                                        {(Array.isArray(formState.compliance_types) ? formState.compliance_types : []).length === 0 ? (
                                            <span className="text-xs text-gray-500 italic">None selected</span>
                                        ) : (
                                            formState.compliance_types.map((t) => (
                                                <span
                                                    key={t}
                                                    className={`inline-flex items-center gap-1 border px-2 py-1 rounded-full text-xs font-medium ${compliancePillClass(t)}`}
                                                    title={t}
                                                >
                                                    {t}
                                                </span>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Risk Owner, Department, Status, Definition Date */}
                        <div className="grid grid-cols-4 gap-4 mb-6">
                            {/*<input
                    type="text"
                    placeholder="Risk Owner"
                    className="p-3  rounded bg-[#EEF0ED] text-black h-10"
                />*/}

                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Control Type</label>
                                <Select
                                    options={listControlTypes}
                                    placeholder="Control Type"
                                    onChange={(e) => handleRiskChange({ ...formState, ControlType: e })}
                                    styles={customStyles}
                                    value={formState.ControlType}
                                    className="text-sm"
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Compliance Types</label>
                                <Select
                                    isMulti
                                    options={complianceOptions}
                                    placeholder="Select Compliance Types"
                                    closeMenuOnSelect={false}          // keep menu open
                                    hideSelectedOptions={false}        // still show selected items
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={false}   // no chips
                                    components={{ Option, ValueContainer, ClearIndicator }}
                                    styles={customStyles}
                                    className="text-sm"
                                    value={Array.isArray(formState.compliance_types)
                                        ? formState.compliance_types.map(v => ({ value: v, label: v }))
                                        : []}
                                    onChange={(selected) => {
                                        const values = selected ? selected.map(s => s.value) : [];
                                        setFormState(prev => ({ ...prev, compliance_types: values }));
                                        handleRiskChange({ ...formState, compliance_types: values });
                                    }}
                                />
                            </div>


                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Control Owner</label>
                                <Select
                                    options={listUsers}
                                    placeholder="Owner"
                                    styles={customStyles}
                                    value={formState.User ?? null}   // must be the option object
                                    onChange={(e) => {
                                        const opt = listUsers.find(u => String(u.value) === String(e?.value)) ?? null;
                                        setFormState(prev => ({ ...prev, User: opt }));      // keep option object in state
                                        //handleRiskChange({ ...formState, User: e?.value });  // send only the ID to backend
                                    }}
                                />
                            </div>




                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Control Efficiency</label>
                                <div className="relative w-32 mt-2 h-6 bg-gray-200 rounded-full flex items-center">

                                    <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        step="5"
                                        value={formState.ControlEfficiency || 0}
                                        onChange={(e) => handleRiskChange({ ...formState, ControlEfficiency: e.target.value })}
                                        className="absolute w-32 h-6 appearance-none bg-transparent rounded-full"
                                        style={{ background: `linear-gradient(to right, #09A6B0 ${formState.ControlEfficiency || 0}%, #f07167 ${formState.ControlEfficiency || 0}%)` }}
                                    />
                                    <span className="relative text-white text-sm ml-2">
                                        {formState.ControlEfficiency || 0}%
                                    </span>
                                </div>
                            </div>

                        </div>

                        {/* Checklist */}

                        <div className="flex flex-col mb-4">

                            {/* Checklist Title with Counter and Progress Bar */}
                            <div className="flex items-center justify-between mb-2">
                                <label className="text-[#3b3b3b] mb-0 text-sm">
                                    Checklist {formState.Checklist?.filter(item => item.completed).length || 0}/{formState.Checklist?.length || 0}
                                </label>
                                {(formState.Checklist?.filter(item => item.completed).length || 0) > 0 && (
                                    <div className="ml-4 relative flex-1 h-1 bg-gray-200 rounded-md overflow-hidden">
                                        <div
                                            className="absolute top-0 left-0 h-full bg-[#3b3b3b] rounded-md transition-all duration-500"
                                            style={{
                                                width: `${((formState.Checklist?.filter(item => item.completed).length || 0) / (formState.Checklist?.length || 1)) * 100
                                                    }%`,
                                            }}
                                        ></div>
                                    </div>
                                )}
                            </div>

                           
                            {/* Checklist Items */}
                            <ul className="bg-transparent rounded-md p-0 w-full">
                                {formState.Checklist &&
                                    formState.Checklist.map((item, index) => (
                                        <li
                                            key={item.checklist_id || index}
                                            className="flex items-center justify-between mb-0 p-1 rounded hover:bg-[#EEF0ED]"
                                        >
                                            <div className="flex items-center w-full">
                                                {/* 🔹 Drag handle */}
                                                <div
                                                    draggable
                                                    onDragStart={(e) => {
                                                        e.dataTransfer.effectAllowed = "move";
                                                        e.dataTransfer.setData("text/plain", item.text || "");
                                                        setDraggedChecklistItem({ ...item, index });
                                                    }}
                                                    onDragEnd={() => setDraggedChecklistItem(null)}
                                                    className="mr-2 cursor-move px-1 py-1 rounded hover:bg-gray-200 select-none"
                                                >
                                                    {/* You can swap this for an icon if you want */}
                                                    <span className="text-xs text-gray-500">⋮⋮</span>
                                                </div>

                                                {/* Checkbox */}
                                                <input
                                                    type="checkbox"
                                                    className="appearance-none h-3 w-3 border-2 border-gray-300 rounded-full checked:bg-[#3b3b3b] checked:border-[#3b3b3b] focus:outline-none cursor-pointer"
                                                    checked={item.completed}
                                                    onChange={(e) => {
                                                        const updatedChecklist = formState.Checklist.map((checkItem, idx) =>
                                                            idx === index ? { ...checkItem, completed: e.target.checked } : checkItem
                                                        );
                                                        handleRiskChange({ ...formState, Checklist: updatedChecklist });
                                                    }}
                                                />

                                                {/* Text input */}
                                                <input
                                                    type="text"
                                                    value={item.text}
                                                    onChange={(e) => {
                                                        const updatedChecklist = formState.Checklist.map((checkItem, idx) =>
                                                            idx === index ? { ...checkItem, text: e.target.value } : checkItem
                                                        );
                                                        handleRiskChange({ ...formState, Checklist: updatedChecklist });
                                                    }}
                                                    className={`p-1 text-sm bg-transparent focus:border-none focus:outline-none w-full ${item.completed ? "line-through text-gray-500" : "text-black"
                                                        }`}
                                                    placeholder="Enter checklist item"
                                                    disabled={item.completed}
                                                />
                                            </div>

                                            {/* Trash */}
                                            <button
                                                className="text-black ml-2 hover:text-red-600"
                                                onClick={() => {
                                                    const updatedChecklist = formState.Checklist.filter((_, idx) => idx !== index);
                                                    handleRiskChange({ ...formState, Checklist: updatedChecklist });
                                                }}
                                            >
                                                <TfiTrash size={16} />
                                            </button>
                                        </li>
                                    ))}
                            </ul>


                            {/* Add New Checklist Item */}
                            <div className="flex items-center p-1 rounded hover:bg-[#EEF0ED] mt-2" ref={dropRef}>
                                <input
                                    type="checkbox"
                                    className="appearance-none h-3 w-3 border-2 border-gray-300 rounded-full checked:bg-[#3b3b3b] checked:border-[#3b3b3b] focus:outline-none cursor-default"
                                    disabled // Checkbox is disabled for the add item row
                                />
                                <input
                                    type="text"
                                    className="p-1 text-sm text-black bg-transparent focus:border-none focus:outline-none w-full"
                                    placeholder="Add checklist item"
                                    value={newItemLocal || ""}
                                    onChange={(e) => {
                                        setNewItemLocal(e.target.value);
                                        handleRiskChange({ ...formState, newItem: e.target.value });
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" && newItemLocal.trim()) {
                                            e.preventDefault();
                                            const newChecklist = [
                                                ...formState.Checklist,
                                                { text: newItemLocal.trim(), completed: false },
                                            ];
                                            setNewItemLocal("")
                                            handleRiskChange({ ...formState, Checklist: newChecklist, newItem: "" });
                                        }
                                    }}
                                    onBlur={() => {
                                        if (newItemLocal?.trim()) {
                                            const newChecklist = [
                                                ...formState.Checklist,
                                                { text: newItemLocal.trim(), completed: false },
                                            ];
                                            handleRiskChange({ ...formState, Checklist: newChecklist, newItem: "" });
                                        }
                                    }}
                                />

                            </div>
                        </div>
                        {/* <div className="flex items-center gap-4 mt-2 mb-2">
                            <button
                                onClick={() => handleAISuggestions()}
                                className={`relative bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white rounded px-4 py-2 shadow-lg transition duration-300 ease-in-out hover:shadow-2xl hover:scale-105 focus:outline-none ${loadingAI ? 'animate-pulse' : ''
                                    }`}
                                disabled={loadingAI}
                                style={{
                                    minWidth: '100px',
                                    minHeight: '28px',
                                    boxShadow: loadingAI
                                        ? '0 0 20px 5px rgba(139, 92, 246, 0.8)'
                                        : '0 0 5px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <span className="absolute inset-0 rounded blur-md opacity-50 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></span>
                                <span className="relative">Ask Rabo</span>
                            </button>
                        </div> */}

                        <div className="mb-4">
                            <label className="text-[#3b3b3b] mb-2 text-sm">Attachments</label>

                            {/* Display uploaded attachment titles */}

                            <ul className="mt-2">
                                {formState.Attachments && formState.Attachments?.length > 0 && (
                                    formState.Attachments.map((attachment) => (
                                        <li
                                            key={attachment.attachment_id}
                                            className="flex justify-between items-center bg-[#EEF0ED] border border-gray-200 rounded p-4 my-4 max-w-sm hover:bg-[#E5E7E4] shadow-sm"
                                        >
                                            <a
                                                href={attachment.file_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-[#3b3b3b] hover:underline flex-1 text-sm"
                                            >
                                                {attachment.attachment_name
                                                    ? (attachment.attachment_name.length > 36
                                                        ? `${attachment.attachment_name.slice(0, 36)}...`
                                                        : attachment.attachment_name)
                                                    : "Unnamed Attachment"}
                                            </a>
                                            <button
                                                className="text-black ml-2"
                                                onClick={() => handleDeleteAttachment(attachment.attachment_id)}
                                            >
                                                <TfiTrash size={16} />
                                            </button>
                                        </li>
                                    ))
                                )}
                            </ul>

                            <button
                                className="bg-white text-black text-sm border border-gray-100 py-2 px-4 mb-4 rounded hover:bg-gray-100 shadow-md"
                                onClick={() => fileInputRef.current.click()} // Trigger file input click
                            >
                                Add Attachments
                            </button>

                            <input

                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={(event) => handleFileChange(event, control_id)}
                                multiple // Allow multiple file selection
                            />
                        </div>








                        {/* Findings block (inline, improved styling) */}
                        <div className="flex flex-col mb-4 w-full">
                            <div className="flex items-center justify-between mb-2">
                                <label className="text-[#3b3b3b] text-sm font-medium">Findings</label>
                                <button
                                    onClick={async () => {
                                        if (!control_details?.control_id) return;
                                        handleAddFinding(control_details?.control_id);
                                    }}
                                    disabled={findingBusy || !control_details?.control_id}
                                    className="h-9 px-4 rounded-md bg-[#3b3b3b] text-white text-sm font-medium hover:bg-[#2f2f2f] disabled:opacity-60 transition"
                                >
                                    {findingBusy ? "Adding…" : "+ New Finding"}
                                </button>
                            </div>

                            {/* ✅ w-full so table can use all available space */}
                            <div className="w-full rounded-lg border border-gray-200 overflow-hidden bg-white"
                                onDragOver={(e) => {
                                    // allow drop
                                    e.preventDefault();
                                }}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    if (!draggedChecklistItem) return;

                                    console.log("Dropped checklist item onto Findings:", draggedChecklistItem);
                                    handleDropFinding(draggedChecklistItem);
                                    // later: call AI + create finding
                                    setDraggedChecklistItem(null);
                                }}

                            >
                                <table className="w-full text-sm table-auto" style={{ tableLayout: "auto" }}>

                                    {/* Header */}
                                    <thead>
                                        <tr style={{ height: 28 }}>
                                            {/* ID – small */}
                                            <th
                                                style={{
                                                    background: "#E2E4E0",
                                                    color: "#1F1F1F",
                                                    fontSize: 13,
                                                    fontWeight: 500,
                                                    padding: "4px 12px",
                                                    height: 28,
                                                    borderBottom: "1px solid #D8DBD6",
                                                    width: "20%",
                                                }}
                                                className="text-left"
                                            >
                                                ID
                                            </th>

                                            {/* ⭐ TITLE – grab most of the space */}
                                            <th
                                                style={{
                                                    background: "#E2E4E0",
                                                    color: "#1F1F1F",
                                                    fontSize: 13,
                                                    fontWeight: 500,
                                                    padding: "4px 12px",
                                                    height: 28,
                                                    borderBottom: "1px solid #D8DBD6",
                                                    width: "40%",          // <-- important
                                                }}
                                                className="text-left"
                                            >
                                                Title
                                            </th>

                                            {/* DATE – compact */}
                                            <th
                                                style={{
                                                    background: "#E2E4E0",
                                                    color: "#1F1F1F",
                                                    fontSize: 13,
                                                    fontWeight: 500,
                                                    padding: "4px 12px",
                                                    height: 28,
                                                    borderBottom: "1px solid #D8DBD6",
                                                    width: "120px",
                                                }}
                                                className="text-left whitespace-nowrap"
                                            >
                                                Date
                                            </th>

                                            {/* STATUS – compact */}
                                            <th
                                                style={{
                                                    background: "#E2E4E0",
                                                    color: "#1F1F1F",
                                                    fontSize: 13,
                                                    fontWeight: 500,
                                                    padding: "4px 12px",
                                                    height: 28,
                                                    borderBottom: "1px solid #D8DBD6",
                                                    width: "120px",
                                                }}
                                                className="text-left"
                                            >
                                                Status
                                            </th>

                                            {/* Trash column – tiny */}
                                            <th
                                                style={{
                                                    background: "#E2E4E0",
                                                    color: "#1F1F1F",
                                                    fontSize: 13,
                                                    fontWeight: 500,
                                                    padding: "4px 12px",
                                                    height: 28,
                                                    borderBottom: "1px solid #D8DBD6",
                                                    width: "40px",
                                                }}
                                                className="text-right"
                                            />
                                        </tr>
                                    </thead>


                                    <tbody>
                                        {((control_details?.findings?.filter((f) => f.type === 0) ?? [])
                                            .length === 0) && (
                                                <tr>
                                                    <td colSpan={5} className="px-3 py-4 text-gray-500 text-sm">
                                                        No findings yet.
                                                    </td>
                                                </tr>
                                            )}

                                        {(control_details?.findings?.filter((f) => f.type === 0) ?? []).map(
                                            (f) => {
                                                const formattedId = `AUD-${new Date().getFullYear()}-${String(
                                                    f.id
                                                ).padStart(3, "0")}`;
                                                const d = f.finding_date || f.date;
                                                const dateStr = d ? new Date(d).toLocaleDateString() : "";
                                                const status = f.status || "Open";

                                                const statusColor =
                                                    status === "Closed"
                                                        ? "bg-green-100 text-green-700 border-green-300"
                                                        : status === "Problem"
                                                            ? "bg-purple-100 text-purple-700 border-purple-300"
                                                            : "bg-blue-100 text-blue-700 border-blue-300";

                                                return (
                                                    <tr
                                                        key={f.id}
                                                        className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer"
                                                        onClick={() => handleFindingClick(f.id)}
                                                    >
                                                        <td className="px-3 py-2 text-gray-700 font-medium">
                                                            {formattedId}
                                                        </td>
                                                        <td className="px-3 py-2 text-gray-900">
                                                            {f.title?.trim() || "(untitled)"}
                                                        </td>
                                                        <td className="px-3 py-2 text-gray-700">{dateStr}</td>
                                                        <td className="px-3 py-2">
                                                            <span
                                                                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border ${statusColor}`}
                                                            >
                                                                {status}
                                                            </span>
                                                        </td>
                                                        <td
                                                            className="px-2 py-2"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <div className="flex justify-end w-full">
                                                                <TfiTrash
                                                                    size={14}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteFinding?.(f.id);
                                                                    }}
                                                                    className="text-gray-400 hover:text-red-500 transition-colors duration-150 cursor-pointer"
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>





                        {<h1 className="text-1xl mt-6 font-semibold text-[#3b3b3b]">Second Line</h1>}
                        <div className="flex items-center mt-2 mb-4">
                            <p className="text-[#3b3b3b] text-sm mr-2">Add control to second line</p>
                            <label className="inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    value=""
                                    className="sr-only peer"
                                    checked={formState.is_secondline}
                                    onChange={(e) =>
                                        handleRiskChange({
                                            ...formState,
                                            is_secondline: e.target.checked,
                                            //Secondline: e.target.checked ? formState.Secondline : '',
                                            Secondline: formState.Secondline,
                                        })
                                    }
                                />
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#00AFB9]"></div>
                            </label>
                        </div>
                    </div>
                )}


                <div className={`p-6 bg-white rounded-lg`}>

                    {currentPage === 2 && (

                        <>
                            <div className="flex justify-between items-center mb-1">
                                <label className="text-[#3b3b3b] mb-1 text-sm">Instructions</label>
                            </div>
                            <textarea
                                placeholder="Second Line Instructions"
                                className="w-full p-3 text-sm rounded bg-[#EEF0ED] text-black"
                                style={{
                                    border: 'none', // Remove actual borders
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                                value={formState.Secondline}
                                onChange={(e) =>
                                    handleRiskChange({ ...formState, Secondline: e.target.value })
                                }
                            />

                            {/* Secondary Findings block (type = 1) */}
                            <div className="flex flex-col mb-4">
                                <div className="flex items-center justify-between mb-2">
                                    <label className="text-[#3b3b3b] text-sm font-medium">Findings</label>
                                    <button
                                        onClick={async () => {
                                            if (!control_details?.control_id) return;
                                            handleAddFindingSecond(control_details?.control_id, 1);
                                        }}
                                        disabled={findingBusy || !control_details?.control_id}
                                        className="h-9 px-4 rounded-md bg-[#3b3b3b] text-white text-sm font-medium hover:bg-[#2f2f2f] disabled:opacity-60 transition"
                                    >
                                        {findingBusy ? "Adding…" : "+ New Finding"}
                                    </button>
                                </div>

                                <div className="rounded-lg border border-gray-200 overflow-hidden bg-white">
                                    <table className="w-full text-sm">
                                        {/* ✅ Compact darker header */}
                                        {/* Header */}
                                        <thead>
                                            <tr style={{ height: 28 }}>
                                                {/* ID – small */}
                                                <th
                                                    style={{
                                                        background: "#E2E4E0",
                                                        color: "#1F1F1F",
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        padding: "4px 12px",
                                                        height: 28,
                                                        borderBottom: "1px solid #D8DBD6",
                                                        width: "20%",
                                                    }}
                                                    className="text-left"
                                                >
                                                    ID
                                                </th>

                                                {/* ⭐ TITLE – grab most of the space */}
                                                <th
                                                    style={{
                                                        background: "#E2E4E0",
                                                        color: "#1F1F1F",
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        padding: "4px 12px",
                                                        height: 28,
                                                        borderBottom: "1px solid #D8DBD6",
                                                        width: "40%",          // <-- important
                                                    }}
                                                    className="text-left"
                                                >
                                                    Title
                                                </th>

                                                {/* DATE – compact */}
                                                <th
                                                    style={{
                                                        background: "#E2E4E0",
                                                        color: "#1F1F1F",
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        padding: "4px 12px",
                                                        height: 28,
                                                        borderBottom: "1px solid #D8DBD6",
                                                        width: "120px",
                                                    }}
                                                    className="text-left whitespace-nowrap"
                                                >
                                                    Date
                                                </th>

                                                {/* STATUS – compact */}
                                                <th
                                                    style={{
                                                        background: "#E2E4E0",
                                                        color: "#1F1F1F",
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        padding: "4px 12px",
                                                        height: 28,
                                                        borderBottom: "1px solid #D8DBD6",
                                                        width: "120px",
                                                    }}
                                                    className="text-left"
                                                >
                                                    Status
                                                </th>

                                                {/* Trash column – tiny */}
                                                <th
                                                    style={{
                                                        background: "#E2E4E0",
                                                        color: "#1F1F1F",
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        padding: "4px 12px",
                                                        height: 28,
                                                        borderBottom: "1px solid #D8DBD6",
                                                        width: "40px",
                                                    }}
                                                    className="text-right"
                                                />
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {((control_details?.findings?.filter((f) => f.type === 1) ?? []).length === 0) && (
                                                <tr>
                                                    <td colSpan={5} className="px-3 py-4 text-gray-500">
                                                        No findings of this type.
                                                    </td>
                                                </tr>
                                            )}

                                            {control_details?.findings
                                                ?.filter((f) => f.type === 1)
                                                ?.map((f) => {
                                                    const formattedId = `AUD-${new Date().getFullYear()}-${String(f.id).padStart(3, '0')}`;
                                                    const d = f.finding_date || f.date;
                                                    const dateStr = d ? new Date(d).toLocaleDateString() : '';
                                                    const status = f.status || 'Open';

                                                    const statusColor =
                                                        status === 'Closed'
                                                            ? 'bg-green-100 text-green-700 border-green-300'
                                                            : status === 'Problem'
                                                                ? 'bg-purple-100 text-purple-700 border-purple-300'
                                                                : 'bg-blue-100 text-blue-700 border-blue-300';

                                                    return (
                                                        <tr
                                                            key={f.id}
                                                            className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer"
                                                            onClick={() => handleFindingClick(f.id)}
                                                        >
                                                            <td className="px-3 py-2 text-gray-700 font-medium">{formattedId}</td>
                                                            <td className="px-3 py-2 text-gray-900">{f.title?.trim() || '(untitled)'}</td>
                                                            <td className="px-3 py-2 text-gray-700">{dateStr}</td>
                                                            <td className="px-3 py-2">
                                                                <span
                                                                    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border ${statusColor}`}
                                                                >
                                                                    {status}
                                                                </span>
                                                            </td>
                                                            <td className="px-2 py-2" onClick={(e) => e.stopPropagation()}>
                                                                <div className="flex justify-end w-full">
                                                                    <TfiTrash
                                                                        size={14}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleDeleteFinding?.(f.id);
                                                                        }}
                                                                        className="text-gray-400 hover:text-red-500 transition-colors duration-150 cursor-pointer"
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>





                            <div
                                className="flex gap-4 mt-4 mb-4"
                                style={{ paddingBottom: "1rem" }}
                            >
                                <div className="flex flex-col mb-4">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Start Date</label>
                                    <input
                                        type="date"
                                        placeholder="Start Date"
                                        className="p-2 mr-2 rounded bg-[#EEF0ED] text-sm text-black h-10"
                                        value={formState.StartDate ? formatDateForInput(formState.StartDate) : ''}
                                        onChange={(e) =>
                                            handleRiskChange({ ...formState, StartDate: e.target.value })
                                        }
                                    />
                                </div>

                                <div className="flex flex-col mb-4">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">End Date</label>
                                    <input
                                        type="date"
                                        placeholder="End Date"
                                        className="p-2  rounded bg-[#EEF0ED] text-sm text-black h-10"
                                        value={formState.EndDate || ''}
                                        onChange={(e) =>
                                            handleRiskChange({ ...formState, EndDate: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Control Period</label>
                                    <Select
                                        options={listControlPeriods}
                                        placeholder="Control Period"
                                        onChange={(e) => handleRiskChange({ ...formState, ControlPeriod: e })}
                                        styles={customStyles}
                                        value={formState.ControlPeriod}
                                        className=" text-sm"
                                    />
                                </div>
                            </div>

                        </>
                    )}




                    <h3 className="font-semibold mb-3 text-[#3b3b3b]">Comments</h3>

                    {/* Comments */}
                    <div className="mb-6">
                        <textarea
                            placeholder="Comments"
                            className="w-full p-3 text-sm rounded bg-[#EEF0ED] text-black"
                            style={{
                                border: 'none', // Remove actual borders
                                backgroundColor: '#EEF0ED',
                                padding: '8px',
                                outline: 'none',
                                transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                            }}
                            onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                            onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                            value={commentState}
                            onChange={(e) => setCommentState(e.target.value)}
                        />

                        <div className="flex justify-end mt-4">
                            <button className="bg-[#3b3b3b] text-white py-2 px-4 text-sm rounded hover:bg-opacity-70" onClick={() => { if (commentState) { addControlCommentFN(commentState, control_id); setCommentState(''); } }}>Add Comment</button>
                        </div>

                    </div>

                    {/* Mark Jones Comment */}

                    {
                        control_comments && control_comments?.length > 0 && control_comments.map((comment, index) => (
                            <div className="bg-[#EEF0ED] p-4 rounded-[5px] text-gray-600 mb-4">
                                <div className="flex justify-between">
                                    <span className="font-semibold">{comment.FirstName} {comment.LastName}</span>
                                    <span>{moment(comment.CommentDate).format('MM/DD/YYYY HH:mm:ss')}</span>
                                </div>
                                <p className="mt-2">{comment.CommentText}</p>
                            </div>
                        ))
                    }


                </div >

            </div>
            {/* FINDING OVERLAY (level 3, inside ControlOverlay) */}
            <Popup
                open={isFindingOpen}
                onClose={closeFinding}
                modal
                nested
                closeOnDocumentClick={false}
                closeOnEscape
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh', zIndex: 1100 }}
                overlayStyle={{ zIndex: 1099 }}
            >
                {/* block any propagation inside */}
                <div
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                >
                    <FindingOverlay
                        key={findingId || 'new_finding'}
                        finding_id={findingId}
                        closeFinding={(data, id, e) => {
                            e?.stopPropagation?.();
                            closeFinding(data, id);
                        }}
                    />
                </div>
            </Popup>


        </Disable >
    );

};


const mapStateToProps = (state) => {
    console.log("New Form", state.risk.control_details)
    return {

        risk: state.risk.risk,
        profile: state.profile.profile,
        control_details: state.risk.control_details,
        control_comments: state.risk.control_comments,
        users: state.admin.admin_users,
        findings: state.risk.control_details?.findings,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        //getRiskFN: (id) => dispatch(getRisk(id)),
        //addCommentFN: (comment, risk_id) => dispatch(addComment(comment, risk_id)),
        // addControlFN: (risk_id) => dispatch(addControl(risk_id)),
        // addActionFN: (risk_id) => dispatch(addAction(risk_id)),
        addAttachmentFN: (risk_id, control_id, file) => dispatch(addAttachment(risk_id, control_id, file)),
        //editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
        //editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        deleteControlFN: (risk_id, action_id) => dispatch(deleteControl(risk_id, action_id)),
        getControlDetailsFN: (risk_id, control) => dispatch(getControlDetails(risk_id, control)),
        addControlCommentFN: (comment, control_id) => dispatch(addControlComment(comment, control_id)),
        deleteAttachmentFN: (control_id, attachment_id) => dispatch(deleteAttachment(control_id, attachment_id)), // Add this line
        getUsersFN: () => dispatch(getUsers()),
        addFindingFN: (control_id, type) => dispatch(addFinding(control_id, type)),
        addFindingAIFN: (control_id, aiResponse) => dispatch(addFindingAI(control_id, aiResponse)),
        updateFindingFN: (data, id) => dispatch(updateFinding(data, id)),
        deleteFindingFN: (id) => dispatch(deleteFinding(id)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(ControlOverlay);